import { download, generateCsv, mkConfig } from "export-to-csv"
import { useCallback } from "react"
import { useDateTime } from "../../../../../localization/useDateTime"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { Device } from "../../../../../entities/devices/deviceTypes"

type useExportOrdersToCsvParams = Readonly<{
    data: Device[] | null | undefined
}>
export function useExportDeviceToCsv({ data }: useExportOrdersToCsvParams) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()
    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-Service-Center-Devices`,
    })

    const mapDeviceToCsvRow = (device: Device) => ({
        deviceName: device.name,
        deviceType: device.type,
        deviceNumber: device.id,
    })

    return useCallback(() => {
        const exportRows = data && data.length > 0 ? data.map((device) => mapDeviceToCsvRow(device)) : []

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }, [dateTimeFactory, data, l10n])
}
